import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-符号-数据矩阵",
  "use": "icon-符号-数据矩阵-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-符号-数据矩阵\"><defs><style type=\"text/css\"></style></defs><path d=\"M192 224h128v128H192z m0 448h128v128H192z m0-224h128v128H192z m-64-288h64V96H64v832h128v-64h-64z m576 64h128v128H704z m0 224h128v128H704z m128-288h64v704h-64v64h128V96H832z m-384 64h128v128H448z m256 448h128v128H704zM448 448h128v128H448z m0 224h128v128H448z\" fill=\"#333333\" p-id=\"3693\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/符号-数据矩阵.svg
// module id = dFLr
// module chunks = 54